import { Howl } from 'howler';
// 播放单个音频文件
export default class HowlerPlayer {
  constructor(props = {}) {
    const { html5 = true, src, setIsPlaying, ...others } = props;
    this.props = props;
    this.sound = new Howl({
      html5,
      src: [src],
      onplay: this.onplay,
      onload: this.onload,
      onseek: this.onseek,
      onrate: this.onrate,
      ...others,
      onend: this.onend,
    });
    this.sound.on('play', () => {
      this.isPlaying = true;
      if (setIsPlaying) {
        setIsPlaying(true);
      }
    });
    this.sound.on('pause', () => {
      this.isPlaying = false;
      if (setIsPlaying) {
        setIsPlaying(false);
      }
    });
    this.sound.on('stop', () => {
      this.isPlaying = false;
      if (setIsPlaying) {
        setIsPlaying(false);
      }
    });
    this.sound.on('end', () => {
      this.isPlaying = false;
      if (setIsPlaying) {
        setIsPlaying(false);
      }
    });
  }

  onrate = () => {
    if (this.props.onrate) {
      this.props.onrate(this.sound.rate(this.id));
    }
  };

  rate = value => {
    this.sound.rate(value, this.id);
  };

  onplay = () => {
    this.raf();
  };

  onload = () => {
    if (this.props.onload) {
      this.props.onload();
    }
  };

  onseek = () => {
    this.raf();
  };

  onend = () => {
    this.pause();
    if (this.props.onend) {
      this.props.onend();
    }
  };

  seek = val => {
    this.sound.seek(val);
  };

  getDuration = () => this.sound.duration();

  destory = () => {
    this.sound.unload();
    this.sound = null;
  };

  toggle = () => {
    // 切换播放和暂停
    if (this.isPlaying) {
      this.pause();
    } else {
      this.play();
    }
  };

  play = () => {
    this.id = this.sound.play(this.id);
    if (this.props.play) {
      this.props.play();
    }
  };

  pause = () => {
    this.sound.pause(this.id);
    if (this.props.onpause) {
      this.props.onpause();
    }
  };

  raf = () => {
    requestAnimationFrame(this.step);
  };

  step = () => {
    if (!this.sound) {
      return;
    }
    const seek = this.sound.seek() || 0;
    this.props.duration(seek); // 返回当前所处位置
    if (this.sound.playing() || this.isPlaying) {
      // 播放时不断返回位置
      this.raf();
    }
  };
}
